import {
  CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_BEGIN,
  CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_SUCCESS,
  CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_FAILURE,
  CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_DISMISS_ERROR,
} from './constants';

import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function deleteCustomFunction(args = {}) {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_BEGIN,
    });

    const header = builderSurfaceJsonContentHeader(args.projectId);
    const version = Number(args.version);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/custom-function/${args.uuid}`,
        header,
      );

      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_SUCCESS,
              data: res.data,
            });
            toast.success('Function Deleted Successfully');
            resolve(res);
          } else {
            dispatch({
              type: CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteCustomFunctionError() {
  return {
    type: CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_BEGIN:
      return {
        ...state,
        deleteCustomFunctionPending: true,
        deleteCustomFunctionError: null,
      };

    case CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_SUCCESS:
      const customFunctions = state.customFunctions.filter(
        (func) => func.uuid !== action.data.uuid,
      );
      return {
        ...state,
        deleteCustomFunctionPending: false,
        deleteCustomFunctionError: null,
        customFunctions,
      };

    case CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_FAILURE:
      return {
        ...state,
        deleteCustomFunctionPending: false,
        deleteCustomFunctionError: action.data.error,
      };

    case CUSTOM_COMPONENT_DELETE_CUSTOM_FUNCTION_DISMISS_ERROR:
      return {
        ...state,
        deleteCustomFunctionError: null,
      };

    default:
      return state;
  }
}
